export default __webpack_public_path__ + "static/media/contactus.7966b139.jpg";